// Mock data for portfolio website

export const personalInfo = {
  name: "Alex Morgan",
  title: "IT & Payroll Manager",
  tagline: "Streamlining Operations | Optimizing Systems | Driving Digital Transformation",
  email: "alex.morgan@example.com",
  phone: "+1 (555) 123-4567",
  location: "San Francisco, CA",
  profileImage: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop",
  bio: "Results-driven IT and Payroll Manager with over 10 years of experience in enterprise systems management, payroll operations, and digital transformation. Passionate about leveraging technology to optimize business processes and enhance operational efficiency.",
  cvUrl: "/assets/cv-sample.pdf"
};

export const socialLinks = [
  { platform: "linkedin", url: "https://linkedin.com/in/alexmorgan", icon: "Linkedin" },
  { platform: "github", url: "https://github.com/alexmorgan", icon: "Github" },
  { platform: "twitter", url: "https://twitter.com/alexmorgan", icon: "Twitter" },
  { platform: "email", url: "mailto:alex.morgan@example.com", icon: "Mail" }
];

export const skills = [
  {
    category: "Payroll Management",
    items: [
      { name: "ADP Workforce Now", level: 95 },
      { name: "Paychex", level: 90 },
      { name: "QuickBooks Payroll", level: 88 },
      { name: "SAP SuccessFactors", level: 85 },
      { name: "Multi-state Compliance", level: 92 }
    ]
  },
  {
    category: "IT Systems",
    items: [
      { name: "ERP Systems", level: 90 },
      { name: "HRIS Implementation", level: 88 },
      { name: "Cloud Infrastructure", level: 85 },
      { name: "Database Management", level: 82 },
      { name: "Cybersecurity", level: 80 }
    ]
  },
  {
    category: "Technical Skills",
    items: [
      { name: "SQL & Data Analysis", level: 90 },
      { name: "Process Automation", level: 88 },
      { name: "Project Management", level: 92 },
      { name: "System Integration", level: 85 },
      { name: "Reporting & Analytics", level: 90 }
    ]
  },
  {
    category: "Leadership",
    items: [
      { name: "Team Management", level: 95 },
      { name: "Stakeholder Relations", level: 92 },
      { name: "Change Management", level: 88 },
      { name: "Budget Planning", level: 85 }
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: "Enterprise Payroll System Migration",
    description: "Led migration of legacy payroll system to ADP Workforce Now for 2,500+ employees across 15 states, reducing processing time by 40%.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
    tags: ["ADP", "Migration", "Process Optimization"],
    date: "2024",
    achievements: [
      "Reduced payroll processing time by 40%",
      "Achieved 99.8% accuracy rate",
      "Zero compliance issues during transition"
    ]
  },
  {
    id: 2,
    title: "HRIS Integration & Automation",
    description: "Implemented automated data sync between HR, payroll, and time-tracking systems, eliminating manual data entry and reducing errors by 75%.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop",
    tags: ["Automation", "HRIS", "Integration"],
    date: "2023",
    achievements: [
      "75% reduction in data entry errors",
      "Saved 20 hours per week in manual processing",
      "Improved employee satisfaction by 30%"
    ]
  },
  {
    id: 3,
    title: "Compliance Dashboard Development",
    description: "Designed and implemented real-time compliance monitoring dashboard for multi-state payroll operations with automated alerts.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
    tags: ["Compliance", "Analytics", "Dashboard"],
    date: "2023",
    achievements: [
      "Real-time compliance monitoring",
      "100% audit pass rate",
      "Proactive risk identification"
    ]
  },
  {
    id: 4,
    title: "Cloud Infrastructure Upgrade",
    description: "Orchestrated migration of payroll and HR systems to AWS cloud infrastructure, improving reliability and reducing costs by 35%.",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=600&fit=crop",
    tags: ["AWS", "Cloud", "Infrastructure"],
    date: "2022",
    achievements: [
      "35% cost reduction",
      "99.9% uptime achieved",
      "Enhanced disaster recovery capabilities"
    ]
  },
  {
    id: 5,
    title: "Self-Service Portal Implementation",
    description: "Launched employee self-service portal for pay stubs, tax forms, and benefit information, reducing HR inquiries by 60%.",
    image: "https://images.unsplash.com/photo-1555421689-d68471e189f2?w=800&h=600&fit=crop",
    tags: ["Employee Portal", "UX", "Self-Service"],
    date: "2022",
    achievements: [
      "60% reduction in HR inquiries",
      "95% employee adoption rate",
      "Improved data accuracy"
    ]
  },
  {
    id: 6,
    title: "Cybersecurity Enhancement Program",
    description: "Implemented comprehensive security protocols and training for payroll systems, achieving SOC 2 compliance certification.",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&h=600&fit=crop",
    tags: ["Security", "Compliance", "SOC 2"],
    date: "2021",
    achievements: [
      "SOC 2 Type II certification achieved",
      "Zero security incidents",
      "Enhanced employee security awareness"
    ]
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Future of Payroll: AI and Automation Trends",
    excerpt: "Exploring how artificial intelligence and automation are transforming payroll management and what it means for professionals in the field.",
    content: "Full blog content would go here...",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=500&fit=crop",
    category: "Technology",
    tags: ["AI", "Automation", "Future Trends"],
    date: "2024-01-15",
    readTime: "5 min read",
    author: "Alex Morgan"
  },
  {
    id: 2,
    title: "Navigating Multi-State Payroll Compliance",
    excerpt: "A comprehensive guide to managing payroll compliance across multiple states, including common pitfalls and best practices.",
    content: "Full blog content would go here...",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=500&fit=crop",
    category: "Compliance",
    tags: ["Compliance", "Best Practices", "Multi-State"],
    date: "2024-01-08",
    readTime: "7 min read",
    author: "Alex Morgan"
  },
  {
    id: 3,
    title: "Cloud Migration: Lessons from the Trenches",
    excerpt: "Real-world insights and lessons learned from migrating critical payroll systems to cloud infrastructure.",
    content: "Full blog content would go here...",
    image: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=800&h=500&fit=crop",
    category: "Technology",
    tags: ["Cloud", "Migration", "AWS"],
    date: "2023-12-20",
    readTime: "6 min read",
    author: "Alex Morgan"
  },
  {
    id: 4,
    title: "Building Efficient Payroll Teams",
    excerpt: "Strategies for recruiting, training, and managing high-performing payroll teams in the modern workplace.",
    content: "Full blog content would go here...",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=500&fit=crop",
    category: "Leadership",
    tags: ["Team Building", "Management", "HR"],
    date: "2023-12-10",
    readTime: "4 min read",
    author: "Alex Morgan"
  },
  {
    id: 5,
    title: "Year-End Payroll Checklist for 2024",
    excerpt: "Essential tasks and considerations for wrapping up the payroll year and preparing for the next.",
    content: "Full blog content would go here...",
    image: "https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=800&h=500&fit=crop",
    category: "Best Practices",
    tags: ["Year-End", "Checklist", "Planning"],
    date: "2023-11-28",
    readTime: "8 min read",
    author: "Alex Morgan"
  },
  {
    id: 6,
    title: "The Role of Data Analytics in Modern Payroll",
    excerpt: "How data analytics and business intelligence are revolutionizing payroll decision-making and strategy.",
    content: "Full blog content would go here...",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=500&fit=crop",
    category: "Technology",
    tags: ["Analytics", "Data", "BI"],
    date: "2023-11-15",
    readTime: "6 min read",
    author: "Alex Morgan"
  }
];

export const categories = [
  { name: "All", count: 6 },
  { name: "Technology", count: 3 },
  { name: "Compliance", count: 1 },
  { name: "Leadership", count: 1 },
  { name: "Best Practices", count: 1 }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "CFO, TechCorp Inc.",
    content: "Alex transformed our payroll operations completely. The migration project was executed flawlessly, and the new system has saved us countless hours.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "VP of Operations, Global Solutions",
    content: "Outstanding technical expertise combined with excellent project management. Alex's work on our HRIS integration exceeded all expectations.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "HR Director, InnovateCo",
    content: "A true professional who understands both the technical and human aspects of payroll management. Highly recommend!",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
    rating: 5
  }
];